const INVITATION_KEY = 'ledgerloop.pendingInvitation';
const MAX_AGE = 7 * 24 * 60 * 60 * 1000;
const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const INVITE_PATH = new RegExp(`^/(${UUID})/invite$`, 'i');
const INVITE_TOKEN = new RegExp(`^${UUID}$`, 'i');

export function safeAuthRedirect(value) {
  // Control characters are deliberately rejected in navigation input.
  // eslint-disable-next-line no-control-regex
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u001f\u007f]/.test(value)) return '/';
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname.startsWith('//') || ['/login', '/page-register'].includes(url.pathname)) return '/';
    return url.pathname + url.search + url.hash;
  } catch { return '/'; }
}

export function invitationFromPath(value) {
  const path = safeAuthRedirect(value);
  const url = new URL(path, window.location.origin);
  const match = url.pathname.match(INVITE_PATH);
  const token = url.searchParams.get('token');
  if (!match || !INVITE_TOKEN.test(token || '') || url.searchParams.getAll('token').length !== 1) return null;
  return { companyId: match[1], token, path: `${url.pathname}?token=${encodeURIComponent(token)}` };
}

export function rememberInvitation(value) {
  const invitation = invitationFromPath(value);
  if (invitation) {
    try { sessionStorage.setItem(INVITATION_KEY, JSON.stringify({ path: invitation.path, savedAt: Date.now() })); }
    catch { /* The encoded redirect still preserves the invitation without storage. */ }
  }
  return invitation;
}

export function forgetInvitation(value) {
  try {
    const stored = JSON.parse(sessionStorage.getItem(INVITATION_KEY) || 'null');
    if (!value || stored?.path === invitationFromPath(value)?.path) sessionStorage.removeItem(INVITATION_KEY);
  } catch { /* Storage may be disabled. */ }
}

export function authRedirectFromSearch(search) {
  const explicit = new URLSearchParams(search).get('redirect');
  if (explicit !== null) {
    const path = safeAuthRedirect(explicit);
    rememberInvitation(path);
    return path;
  }
  try {
    const stored = JSON.parse(sessionStorage.getItem(INVITATION_KEY) || 'null');
    if (stored && Number.isFinite(stored.savedAt) && Date.now() >= stored.savedAt && Date.now() - stored.savedAt < MAX_AGE) {
      return invitationFromPath(stored.path)?.path || '/';
    }
    forgetInvitation();
  } catch { /* No pending invitation. */ }
  return '/';
}

export function authPageLink(page, redirect) {
  const safe = safeAuthRedirect(redirect);
  return safe === '/' ? page : `${page}?redirect=${encodeURIComponent(safe)}`;
}
